(() => {
  function revealFromHash() {
    if (!location.hash.startsWith('#my-size-inquiry-')) return;
    const panel = document.getElementById(location.hash.slice(1));
    if (panel && panel.matches('.my-size-inquiry details')) panel.open = true;
  }
  function setContext(panel, link) {
    const id = link.dataset.variantId;
    const url = new URL(link.href, location.origin);
    url.hash = '';
    panel.querySelector('[data-my-size-id]').value = id;
    panel.querySelector('[data-my-size-variant]').value = link.dataset.variantTitle;
    panel.querySelector('[data-my-size-url]').value = url.href;
    const returnField = panel.querySelector('[name="return_to"]');
    if (returnField) { url.searchParams.set('contact_posted', 'true'); url.hash = panel.id; returnField.value = url.pathname + url.search + url.hash; }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-my-size-link]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const panel = document.getElementById('my-size-inquiry-' + link.dataset.productId);
    if (!panel) return; // Quick view on a collection navigates to the full product page.
    event.preventDefault();
    setContext(panel, link);
    panel.open = true;
    panel.scrollIntoView({behavior: 'smooth', block: 'start'});
    panel.querySelector('summary').focus();
  });
  document.querySelectorAll('[data-my-size-result]').forEach(result => { const panel = result.closest('details'); if (panel) panel.open = true; });
  document.addEventListener('miyolly:variant-updated', event => {
    const {variant, productURL} = event.detail || {};
    if (!variant || !variant.id || !productURL) return;
    document.querySelectorAll('[data-my-size-inquiry]').forEach(root => {
      if (root.dataset.productUrl !== productURL) return;
      const panel = root.querySelector('details');
      const url = new URL(productURL, location.origin);
      url.searchParams.set('variant', variant.id);
      setContext(panel, {href: url.href, dataset: {variantId: variant.id, variantTitle: variant.title || ''}});
    });
  });
  window.addEventListener('hashchange', revealFromHash);
  revealFromHash();
})();
